import type { ComponentProps } from 'react'
import type { Location } from '@/lib/services/locations/locations.types'
import { AdminPageHeader } from '@/components/patterns/admin-page'
import { getLocationName } from '@/lib/services/locations/locations.utils'
import { LocationSettingsActionGroup } from './LocationSettingsActionGroup'

export function DeliveryAndAvailabilityHeader({
  location,
  icon: Icon,
  title,
  description,
}: Pick<ComponentProps<typeof AdminPageHeader>, 'icon' | 'title'> & {
  location?: Location | null
  description?: string
}) {
  return (
    <AdminPageHeader
      className="mb-6 @container/location-settings-header"
      innerClassName="sm:flex-wrap @[64rem]/location-settings-header:flex-nowrap"
      actionsClassName="w-full @[64rem]/location-settings-header:w-auto"
      icon={Icon}
      title={title}
      description={`${description} for ${location ? getLocationName(location) : 'this location'}`}
      actions={
        <LocationSettingsActionGroup
          location={location}
          className="w-full justify-start @[64rem]/location-settings-header:w-auto @[64rem]/location-settings-header:justify-end"
        />
      }
    />
  )
}
